import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NavigationText } from '../../../../../../core/constants/navigation-text';
import { RouteConstants } from '../../../../../../core/constants/routes';
import { NavigationOptions } from '../../../../../../shared/components/page-header-nav/models/navigation-options';
import { PageHeaderNavComponent } from '../../../../../../shared/components/page-header-nav/page-header-nav.component';
import { StepNavigationButtonService } from '../../../../shared/services/step-navigation-button/step-navigation-button.service';
import { PaymentDetailsActionService } from '../../services/payment-details-action/payment-details-action.service';

@Component({
    selector: 'app-payment-details-action-bar',
    templateUrl: './payment-details-action-bar.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [PageHeaderNavComponent],
})
export class PaymentDetailsActionBarComponent implements OnInit {
    navigationItems: NavigationOptions = {};

    constructor(
        private readonly route: ActivatedRoute,
        private readonly router: Router,
        private readonly paymentDetailsActionService: PaymentDetailsActionService,
        private readonly stepNavigationButtonService: StepNavigationButtonService,
    ) {}

    ngOnInit(): void {
        this.setNavigationLinks();
    }

    saveChanges(): void {
        this.paymentDetailsActionService.triggerSaveChangesClick();
    }

    cancel(): void {
        this.router.navigate([RouteConstants.Order.rootUrl]);
    }

    returnToOrder(): void {
        const orderId = this.route.firstChild?.snapshot.paramMap.get('id');
        if (!orderId) {
            this.router.navigate([RouteConstants.Order.rootUrl]);
            return;
        }

        this.router.navigate([RouteConstants.Order.rootUrl, orderId]);
    }

    private setNavigationLinks(): void {
        this.navigationItems.quaternaries = [
            this.stepNavigationButtonService.createCustomCssLink(
                NavigationText.CANCEL,
                '!rounded-lg !border-primary-700 !text-primary-700',
                this.cancel.bind(this),
            ),
        ];

        this.navigationItems.secondaries = [
            this.stepNavigationButtonService.createTertiaryLink(
                NavigationText.RETURN_TO_ORDER,
                this.returnToOrder.bind(this),
            ),
        ];

        this.navigationItems.primaries = [
            this.stepNavigationButtonService.createPrimaryLink(
                NavigationText.SAVE_CHANGES,
                this.saveChanges.bind(this),
            ),
        ];
    }
}
